import {Component, Input, OnInit} from '@angular/core';
import {QuestionModel} from '../../models/question.model';
import {UserModel} from '../../../auth/models/user.model';
import {CandidateModel} from '../../models/candidate.model';
import {JobService} from '../../services/job.service';
import {finalize} from 'rxjs/operators';
import {HttpApiService} from '../../../shared/services/http-api.service';
import {ApiResponseModel} from '../../../shared/entities/api-response.model';

@Component({
  selector: 'app-candidates-show',
  templateUrl: './candidates-show.component.html',
  styleUrls: ['./candidates-show.component.scss'],
})
export class CandidatesShowComponent implements OnInit {

  public loading: boolean;
  public cvLinkList: Array<any> = [];


  constructor(
      private jobService: JobService,
  ) { }

  @Input() candidate: CandidateModel;

  ngOnInit(): void {
      console.log('Candidat ->> ', this.candidate);
      this.getCVLink();
  }

  onDeclineButton(): void {
    this.loading = true;
    this.jobService.declineJobApplication(this.candidate)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.candidate.candidation.status = response.payload.status;
          this.candidate.candidation.updated_at = response.payload.updated_at;
        });
  }

  onAcceptButton(): void {
    this.loading = true;
    this.jobService.acceptJobApplication(this.candidate)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          this.candidate.candidation.status = response.payload.status;
          this.candidate.candidation.updated_at = response.payload.updated_at;
        });
  }

  getCVLink(): void {
    this.loading = true;
    this.jobService.getCvLink(this.candidate.user.uid)
        .pipe(finalize(() => this.loading = false))
        .subscribe((response) => {
          if (response.status === true){
            this.cvLinkList = response.payload;
          }
        });
  }

    public getMediaDetails(): any
    {
        const media = this.cvLinkList[this.cvLinkList.length - 1];

        return {
            name: media.name,
            url: media.url,
        };
    }

    public getCvLink(): void
    {
        this.loading = true;
        this.jobService.getCvLink(this.candidate.user.uid)
            .pipe(finalize(() => this.loading = false))
            .subscribe((response: ApiResponseModel) => {
                this.cvLinkList = response.payload;
            });
    }

  downloadCV(): void {
      window.open(
          this.getMediaDetails().url,
          '_blank' // <- This is what makes it open in a new window.
      );
  }

    openQuestionnaire(): void {

    }

}
